import Dashboard from './pages/Dash.svelte';
import Login from './pages/Login.svelte';
import Shipment from './pages/Shipment.svelte';
import Shipments from './pages/Shipments.svelte';
import Settings from './pages/Settings.svelte';
import Locations from './pages/Locations.svelte';
import Objects from './pages/Objects.svelte';
import ObjectsSettings from './pages/ObjectsSettings.svelte';
import Rows from './pages/Rows.svelte';

const mainRoutes = {

    '/dashboard' : Dashboard,

    '/login' : Login,

    '/settings' : Settings,

    '/locations' : Locations,

    '/shipment/' : Shipment,

    '/shipment/:shipment_id' : Shipment,

    '/shipments/:shipments_ids' : Shipments,

    '/objects/:object_id/settings' : ObjectsSettings,

    '/objects/:object_id' : Objects,

    '/objects/:object_id/:row_id' : Rows,
    
    '*' : Dashboard,
}

export default mainRoutes;